import { apiClient } from "queries/constants";
import { Equipment } from "./types";

export const getEquipment = async () => {
  const response = await apiClient.get<Equipment[]>(`/equipment`);

  return response.data;
};
